import { render, staticRenderFns } from "./AgreementInformationIaModal.vue?vue&type=template&id=6bc05520&scoped=true"
import script from "./AgreementInformationIaModal.vue?vue&type=script&lang=js"
export * from "./AgreementInformationIaModal.vue?vue&type=script&lang=js"
import style0 from "./AgreementInformationIaModal.vue?vue&type=style&index=0&id=6bc05520&prod&lang=css"
import style1 from "./AgreementInformationIaModal.vue?vue&type=style&index=1&id=6bc05520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc05520",
  null
  
)

export default component.exports